import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DocumentsState } from '../reducers/base-documents.reducer';

const getDocumentsRoot = createFeatureSelector<DocumentsState>('documents');

export const getDocumentsState = createSelector(getDocumentsRoot, (state) => state);

export const getDocuments = createSelector(getDocumentsState, (state) => state.documents);
export const getCurrentDocument = createSelector(getDocumentsState, (state) => state.currentDocumentInfo);
export const getDownloadDocument = createSelector(getDocumentsState, (state) => state.downloadDocument);
export const getDocumentCategories = createSelector(getDocumentsState, (state) => state.categories);
